<script lang="ts">
  import {stringify} from 'query-string';
  import {PATHS} from '@/const/paths';
  import {sd} from '@/da';
  import {fixLink$} from '@/store/lang';
  import {envUtil} from '@/helper/env';
  import {getWalletImage} from '@/modules/web3/images';
  import {maskWalletAddress} from '@/modules/web3/assets/overview/utils';
  import {userInfo$} from '@/store/user';
  import {connector$, disconnect} from '@/streams/wallet-connect';
  import {step$} from '../streams';
  import lang from '../DepositDrawer.lang';
  import {getAllKycSummary, is_JP_KR$, showKYCGuide$} from '@/modules/account/overview/stream-kyc';
  import {mc} from '@/core';
  import {onMount} from 'svelte';

  export let LG;
  export let drawerTransitionEnd = false;

  let visible = false;

  $: ({address, walletType: walletName} = $connector$);
  $: walletImage = getWalletImage(walletName);
  $: setTransition(drawerTransitionEnd);

  onMount(async () => {
    await getAllKycSummary();
  });

  function setTransition(drawerTransitionEnd) {
    requestAnimationFrame(() => {
      visible = drawerTransitionEnd;
    });
  }

  function handleDisconnectClick(event) {
    sd.track('web_click', {$screen_name: 'deposit_choose', $element_content: 'wallet_disconnect'});
    disconnect();
  }

  function handleWalletDepositClick() {
    if ($showKYCGuide$) {
      mc.send('toast', 'error', {message: LG(lang.PleaseCompleteAdvance)});
      return;
    }
    sd.track('web_click', {$screen_name: 'deposit_choose', $element_content: 'deposit_wallet'});
    step$.next(address ? 'walletDeposit' : 'chooseWallet');
  }

  function handleOnchainDepositClick() {
    sd.track('web_click', {$screen_name: 'deposit_choose', $element_content: 'deposit_onchain'});
    const {currency} = $$props;
    const query = currency ? '?' + stringify({currency}) : '';
    const path = PATHS.ASSETS_DEPOSIT.pathname;
    const link = `${$fixLink$(path)}${query}`;
    const gotoAction = isCurrentPage(path) ? 'replace' : 'assign';
    window.location[gotoAction](link);
  }

  function handleBuyCryptoClick() {
    sd.track('web_click', {$screen_name: 'deposit_choose', $element_content: 'deposit_buycrypto'});
    const {currency} = $$props;
    const side = 'buy';
    const path = PATHS.FIAT_BUY_CRYPTO_PLACE_ORDER.pathname;
    const link = `${$fixLink$(path)}?${stringify({side, currency})}`;
    const gotoAction = isCurrentPage(path) ? 'replace' : 'assign';
    window.location[gotoAction](link);
  }

  function isCurrentPage(path) {
    return window.location.pathname.endsWith(path);
  }
</script>

<style lang="scss">
  .view-item,
  .title {
    transform: translate3d(calc(-100% - 48px), 0, 0);
    transition: transform 500ms ease-out 0s;
    transition-delay: var(--delay, 100ms);
    will-change: transform;
    &.visible {
      transform: translate3d(0, 0, 0);
    }
  }
  .item {
    padding: 12px 12px 12px 24px;
    &:hover {
      background: #f4f7fe;
      .arrow-icon {
        color: var(--blue);
      }
    }
  }
  .dynamic-item {
    min-height: 50px;
  }
  .disconnect-btn {
    border-radius: 32px;
    padding: 0 14px;
    height: 32px;
    background: #f6f7fb;
    color: #777b83;
  }
  .light-color {
    color: #777b83;
  }
  .t-light {
    color: #999b9f;
  }
  .content-item {
    padding-right: 28px;
  }
  .activity-content {
    color: #0ac51d;
  }
</style>

<div class="main-menu wp100">
  <h1 class="title p0 T1 f32 b" style="--delay:  0ms" class:visible>{LG(lang.Deposit)}</h1>
  <div class="list">
    <div class="view-item" style="--delay:  0ms" class:visible>
      <div class="t-light f16 fw2 mt32">{LG(lang.DepositIntro)}</div>
      <div class="item df aic mt28 cp br8" on:click={handleOnchainDepositClick}>
        <img src="https://img.phemex.com/v1/ebfbe747-5ebd-4ee3-b29b-7dfb456bac34/chain-deposit.svg" width="32" height="32" alt={LG(lang.OnchainDeposit)} srcset="" />
        <div class="ml16 f1">
          <h3 class="p0 T1 f18 b">{LG(lang.OnchainDeposit)}</h3>
          <div class="T4 f14 mt8">{LG(lang.OnchainDepositIntroduction)}</div>
        </div>
        <i class="arrow-icon iconfont T1 f14 b">&#xe60b;</i>
      </div>
      {#if !envUtil.isApp}
        <div class="item dynamic-item df aic mt28 cp br8" on:click={handleWalletDepositClick}>
          {#if address}
            <img src={walletImage} width="36" height="36" alt={walletName} srcset="" />
            <div class="ml16 f1">
              <h3 class="p0 T1 f18 b">{LG(lang.Web3WalletDepsot)}</h3>
              <div class="T4 f14 mt8 df aic">
                <div class="T3">{maskWalletAddress(address)}</div>
                <div class="disconnect-btn ml8 cp df aic jcc f14" on:click|stopPropagation={handleDisconnectClick}>
                  <i class="iconfont f14 b light-color">&#xe655;</i>
                  <div class="ml4 light-color">{LG(lang.Disconnect)}</div>
                </div>
              </div>
            </div>
            <i class="arrow-icon iconfont T1 f14 b">&#xe60b;</i>
          {:else}
            <img src="https://img.phemex.com/v1/7d60b929-48f3-4a8c-8cea-2154955a7481/chanin-wallet.svg" width="32" height="32" alt={LG(lang.Web3WalletDepsot)} srcset="" />
            <div class="ml16 f1">
              <h3 class="p0 T1 f20 b">{LG(lang.Web3WalletDepsot)}</h3>
              <div class="T4 f14 mt8">{LG(lang.Web3WalletDepsotIntroduction)}</div>
            </div>
            <i class="arrow-icon iconfont T1 f14 b">&#xe60b;</i>
          {/if}
        </div>
      {/if}
    </div>

    <div class="view-item" hidden={!$userInfo$.isMain} style="--delay:  100ms" class:visible on:click={handleBuyCryptoClick}>
      <div class="t-light f16 fw2 mt32">{LG(lang.purchaseCryptoAssets)}</div>
      <div class="item df aic mt28 cp br8">
        <img src="https://img.phemex.com/v1/4580ecbc-cf5b-447b-a252-e33ab5261f28/chain-one-click.svg" width="32" height="32" alt={LG(lang.OneClickBuyCrypto)} srcset="" />
        <div class="content-item ml16 f1">
          <h3 class="p0 T1 f18 b">{LG(lang.OneClickBuyCrypto)}</h3>
          <div class="T4 f14 mt8">
            {LG(lang.OneClickBuyCryptoIntroduction)}
          </div>
        </div>
        <i class="arrow-icon iconfont T1 f14 b">&#xe60b;</i>
      </div>
    </div>
  </div>
</div>
